module.exports = __webpack_public_path__ + "img/pic-list4.2de9fb85.jpg";